import type { Card } from '../../types';

/** Epic attack with a Poison rider — composed effects (§3). */
export const VENOMBLADE: Card = {
  id: 'venomblade',
  name: 'Venomblade',
  type: 'attack',
  rarity: 'epic',
  size: { w: 2, h: 2 },
  cost: [
    { kind: 'min', value: 4 },
    { kind: 'min', value: 4 },
  ],
  effects: [
    { kind: 'damage', amount: 8 },
    {
      kind: 'applyStatus',
      application: { status: 'poison', magnitude: 3, duration: 3, target: 'opponent' },
    },
  ],
};
